import axios from "axios";

class GetData {
  constructor() {
    this.result = [];
  }
  CheckStatus = () => {
    const res = async () => {
      const resp = await axios
        .get("account-details/status")
        .catch(function (error) {
          console.log(error);
        });
      this.result = resp;
      console.log(resp);
      return resp;
    };
    return res();
  };

  getSaveDocumentData = () => {

    const res = async () => {
      const resp = await axios
        .get("documents")
        .catch(function (error) {
          console.log(error);
        });
      this.result = resp;
      console.log(resp);
      return resp;
    };
    return res();
  };


  deleteDocuments = (id) => {

    const res = async () => {
      const resp = await axios
        .delete(`documents/${id}`)
        .catch(function (error) {
          console.log(error);
        });
      this.result = resp;
      console.log(resp);
      return resp;
    };
    return res();
  };



  GetNotificationsAndCorrections = () => {

    const res = async () => {
      const resp = await axios
        .get("corrections")
        .catch(function (error) {
          console.log(error);
        });
      this.result = resp;
      console.log(resp);
      return resp;
    };
    return res();
  };


  getSaveAndExistData = () => {

    const res = async () => {
      const resp = await axios
        .get("account-details/id")
        .catch(function (error) {
          console.log(error);
        });
      this.result = resp;
      console.log(resp);
      return resp;
    };
    return res();
  };


  getSavedFileData = (name) => {

    const res = async () => {
      const resp = await axios
        .get(`save-file/${name}`)
        .catch(function (error) {
          console.log(error);
        });
      this.result = resp;
      console.log(resp);
      return resp;
    };
    return res();
  };

  getDetailInfotData = () => {

    const res = async () => {
      const resp = await axios
        .get("account-details/detail-info")


        .catch(function (error) {
          console.log(error);
        });
      this.result = resp;
      console.log(resp);
      return resp;
    };
    return res();
  }

  ResendOtp = () => {
    const res = async () => {
      const resp = await axios
        .get("account-details/resend-otp")
        .catch(function (error) {
          console.log(error);
        });
      this.result = resp;
      console.log(resp);
      return resp;
    };
    return res();
  }

  Return() {
    return this.result;
  }
}
export default new GetData();
